/**
 * The synthetic product id a gift line carries.
 *
 * A gift has no product row, so the order builder invents an id:
 * `-(ruleId × 1000 + n)`, with `n` starting at 1, so several gifts from one
 * rule stay distinct lines. Negative, so nothing mistakes it for a real
 * product.
 *
 * Both halves live here because they have to agree, and in legacy they do not:
 * the builder decodes `floor((|id| − 1) / 1000)` and the kitchen decodes
 * `floor(|id| / 1000)`. At the thousandth gift from a rule the kitchen reads
 * the *next* rule's id and hides a gift the builder gave (FB-052).
 *
 * The stride caps a rule at 1000 gifts per cart. Widening it would renumber
 * every gift id already stored, and a cart is unusable long before it holds a
 * thousand lines from one rule.
 */

const STRIDE = 1000

export function syntheticGiftId(ruleId: number, ordinal: number): number {
  return -(ruleId * STRIDE + ordinal)
}

export function ruleIdFromSyntheticId(productId: number): number {
  return Math.floor((Math.abs(productId) - 1) / STRIDE)
}
